module.exports = __webpack_public_path__ + "images/emoji/rage3.db619317631bb6343e49.png";